import { render, staticRenderFns } from "./StatisticsMarksByFacultyIndex.vue?vue&type=template&id=cd0e5bc6"
import script from "./StatisticsMarksByFacultyIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByFacultyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports